import { Component, Input, OnChanges } from '@angular/core';
import { RentalPoint } from 'src/app/models/rental-point.model';
import { Schedule } from "src/app/models/schedule.model";
import { isEqualDate } from '@progress/kendo-date-math';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-schedule',
    imports: [
        TranslatePipe,
    ],
    templateUrl: './schedule.component.html',
    styleUrl: './schedule.component.scss'
})
export class ScheduleComponent implements OnChanges {
  @Input() rentalPoint?: RentalPoint;
  @Input() date?: Date;
  @Input() onNewLine = false;

  schedule?: Schedule;

  ngOnChanges() {
    const date = this.date;
    const rentalPoint = this.rentalPoint;
    if (!rentalPoint?.schedule || !date) {
      this.schedule = undefined;
      return;
    }

    const schedule = rentalPoint.schedule;
    if (!schedule?.scheduleExceptions || schedule.scheduleExceptions.length === 0) { // has NO schedule exceptions
      this.schedule = schedule;
      return;
    }

    const exceptions = schedule.scheduleExceptions.filter(e => {
      if (e.closingException) return false;
      if (isEqualDate(date, e.startDay) || isEqualDate(date, e.endDay)) return true;
      if (date < e.startDay) return false;
      return date < e.endDay;
    }).filter((e: any) => {
      return e.openingDays.includes(date.getDay());
    });

    if (exceptions.length === 0) {
      this.schedule = schedule;
      return;
    }



    // Rule: returning the last exception that matches the date
    this.schedule = exceptions[exceptions.length - 1] || schedule;
  }

}
